import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/operation', // 运营
  name: 'operation',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.operation',
    requiresAuth: true,
    icon: 'icon-idcard',
    order: 2,
  },
  children: [
    {
      path: 'merchantList', // The midline path complies with SEO specifications
      name: 'merchantList',
      component: () => import('@/views/operation/merchantPerson/index.vue'),
      meta: {
        locale: 'menu.merchantList',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'merchantManage', // The midline path complies with SEO specifications
      name: 'merchantManage',
      component: () => import('@/views/operation/merchant/index.vue'),
      meta: {
        locale: 'menu.merchantManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'rechargeManage', // The midline path complies with SEO specifications
      name: 'rechargeManage',
      component: () => import('@/views/operation/recharge/index.vue'),
      meta: {
        locale: 'menu.rechargeManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default LIST;
